<div class="announcement" *ngIf="shouldBeVisible">
    <p class="announcement-text">
        <span class="typcn typcn-warning-outline"></span>&nbsp;{{ announcement.text }}
    </p>
    <span class="typcn typcn-delete-outline close-icon" (click)="hideAnnouncement()"></span>
</div>